'use client';

import { type FC, memo, type PropsWithChildren } from 'react';
import type { RegistrationSlide, Slide } from '@/api/cms';
import { ScrollTopButton } from '@/components/buttons';
import { useScrollTopBtn } from '@/hooks/scrollTopBtn';
import { FilterGames } from '@/modules/lobby/components/FilterGames';
import { useGetCommonStore } from '@/store';
import { ScContainer } from '@/styles/common';
import PromotionsSlider from '../PromotionsSlider';
import RegistrationSlider from '../RegistrationSlider';
import { ScSliderLayoutContent } from './styled';

interface ILayoutLobbyWithSliderProps extends PropsWithChildren {
  promoSlides: Slide[];
  regSlides: RegistrationSlide[];
  isAuthenticatedByCookie: boolean;
}

export const LayoutLobbyWithSlider: FC<ILayoutLobbyWithSliderProps> = memo(
  ({ children, promoSlides, regSlides, isAuthenticatedByCookie }) => {
    const { containerRef, gamesContainerRightOffset, isTop } =
      useScrollTopBtn();
    const useCommonStore = useGetCommonStore();

    const isAuthenticatedClient = useCommonStore.use.isAuthenticatedByCookie();
    const isAuthenticated =
      typeof window === 'undefined'
        ? isAuthenticatedByCookie
        : isAuthenticatedClient;

    return (
      <>
        {isAuthenticated ? (
          <PromotionsSlider promoSlides={promoSlides} />
        ) : (
          <RegistrationSlider regSlides={regSlides} />
        )}
        <ScSliderLayoutContent>
          <ScrollTopButton isTop={isTop} right={gamesContainerRightOffset} />
          <FilterGames />

          {children}
        </ScSliderLayoutContent>
        <ScContainer ref={containerRef} />
      </>
    );
  }
);
